const SPL_CSS = `
@keyframes splashbar { 0% { transform: translateX(-100%); } 100% { transform: translateX(300%); } }
@keyframes spl-pop { 0% { opacity: 0; transform: scale(.4) rotate(-8deg); } 100% { opacity: 1; transform: scale(1) rotate(0); } }
@keyframes spl-up { 0% { opacity: 0; transform: translateY(14px); filter: blur(4px); } 100% { opacity: 1; transform: translateY(0); filter: blur(0); } }
@keyframes spl-glow { 0%,100% { opacity: .45; transform: scale(.92); } 50% { opacity: 1; transform: scale(1.08); } }
@keyframes spl-spin { to { transform: rotate(360deg); } }
@keyframes spl-fade { from { opacity: 0; } to { opacity: 1; } }
`;

const DEFAULTS = { logo_scale: 1.0, text_scale: 1.0, logo_y: 0, text_y: 0, color: "#22C55E", text: "Jack Cash" };

export function SplashDesign({ cfg, type = "login", loop = false }) {
  const c = { ...DEFAULTS, ...(cfg || {}) };
  const color = c.color || "#22C55E";
  const tagline = type === "logout" ? "See you soon" : "Smart money moves";
  const letters = (c.text || "Jack Cash").split("");

  return (
    <div className="flex flex-col items-center justify-center" data-testid="splash-design">
      <style>{SPL_CSS}</style>

      {/* LOGO block */}
      <div style={{ transform: `translateY(${c.logo_y}px) scale(${c.logo_scale})` }} className="relative">
        <div style={{ position: "absolute", inset: "-18%", borderRadius: "9999px", filter: "blur(28px)",
          background: `radial-gradient(circle, ${color}66 0%, transparent 70%)`,
          animation: `spl-glow 2.4s ease-in-out${loop ? " infinite" : ""}` }} />
        <div style={{ position: "absolute", inset: "-10%", borderRadius: "9999px", border: "2px solid transparent",
          borderTopColor: color, borderRightColor: `${color}55`, animation: "spl-spin 2.2s linear infinite" }} />
        <div style={{ position: "relative", width: 128, height: 128, borderRadius: 30, background: "#fff",
          boxShadow: `0 0 40px ${color}`, display: "grid", placeItems: "center",
          animation: "spl-pop 0.7s cubic-bezier(.2,1.4,.4,1) both" }}>
          <img src="/jackcash-logo.png" alt="" style={{ width: "84%", height: "84%", objectFit: "contain" }} />
        </div>
      </div>

      {/* BRAND TEXT */}
      <div style={{ transform: `translateY(${c.text_y}px) scale(${c.text_scale})`, marginTop: 28, display: "flex" }}>
        {letters.map((ch, i) => (
          <span key={i} style={{
            display: "inline-block", fontSize: "3rem", fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1,
            backgroundImage: `linear-gradient(180deg, #fff 10%, ${color} 95%)`,
            WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent",
            textShadow: `0 0 26px ${color}55`,
            animation: "spl-up 0.5s ease-out both", animationDelay: `${0.35 + i * 0.08}s`,
          }}>{ch === " " ? "\u00A0" : ch}</span>
        ))}
      </div>

      {/* TAGLINE */}
      <div style={{ transform: `translateY(${c.text_y}px)`, marginTop: 8, fontSize: 10, textTransform: "uppercase",
        letterSpacing: "0.4em", color: "rgba(255,255,255,0.6)", animation: "spl-up 0.5s ease-out both", animationDelay: "0.9s" }}>
        {tagline}
      </div>

      {/* LOADING BAR */}
      <div style={{ width: 112, height: 3, marginTop: 28, background: "rgba(255,255,255,0.1)", borderRadius: 9999, overflow: "hidden" }}>
        <div style={{ width: "33.333%", height: "100%", background: `linear-gradient(90deg, transparent, ${color}, transparent)`,
          animation: "splashbar 1.1s ease-in-out infinite" }} />
      </div>
    </div>
  );
}
